export enum DeductFormField {
  Amount = 'amount',
}

export type DeductFormValues = {
  [DeductFormField.Amount]: number;
};
